import { useGroup } from 'hooks/useGroup'
import { useInfinitePosts } from 'hooks/useInfinitePosts'
import { useSubscriptions } from 'hooks/useSubscriptions'
import { useUser } from 'hooks/useUser'

import { useAuth } from 'contexts/AuthContext'

export const useCoachReferral = () => {
  const { initialRoute } = useAuth()
  const isReferral = initialRoute.includes('/group/') && initialRoute.split('/').length === 3
  const username = initialRoute.split('/')[2]

  const { data: user } = useUser({ username })
  const { data: group, isLoading } = useGroup({ userId: user?.id })
  const { data: members } = useSubscriptions({ trainerId: user?.id })

  const { data: posts } = useInfinitePosts({
    creatorId: user?.id,
    filter: 'All posts',
    shouldIncludeDrafts: false,
    limit: 100,
  })
  const workouts = posts.filter((p) => p.isPending === false || p.isPending === undefined)

  return {
    isReferral,
    user,
    group,
    isLoading,
    members,
    workouts,
  }
}
